import { AnchorNode, findClosestDocumentContentNode } from '../anchor';
import { isElement, isText, nextNode } from '../domop';
import { Settings } from './config';
import { getSelectionRangeDetail } from './getSelectionRangeDetail';

const makeTextNode = (parent: Node, text: string) => {
    if (text) {
        const node = document.createTextNode(text);
        parent.appendChild(node);
    }
};

const factoryMakeHighlightNode = (parent: Node, text: string) => {
    if (text) {
        const node = document.createElement('span');
        node.appendChild(document.createTextNode(text));
        parent.appendChild(node);
        return node;
    }
};

const isValidTextNode = (node: Node): node is Text => {
    if (!node.parentNode) {
        // TODO: some nodes were detached, how? Added parentNode check in the mean time
        return false;
    }
    if (!isText(node)) {
        return false;
    }
    if (isElement(node.parentNode) && !Settings.elementWhitelist.includes((node.parentNode as Element).localName)) {
        // Ignore text nodes which have a parent that is not known to be supported.
        return false;
    }
    return true;
};

const textNodesBetween = (nodeStart: Node, nodeEnd: Node): Node[] => {
    const result: Text[] = [];
    for (let node = nodeStart; node; node = nextNode(node)) {
        if (isValidTextNode(node) && findClosestDocumentContentNode(node)) {
            result.push(node);
        }
        if (node === nodeEnd) {
            return result;
        }
    }
    // tslint:disable-next-line
    console.error(`[NoteService] Couldn't find end node`);
    return [];
};

export function applyHighlightSpan(root: AnchorNode, start: string, end: string, created: (node: HTMLSpanElement) => void) {
    const selectionDetails = getSelectionRangeDetail(root, start, end);
    if (!selectionDetails) { return; }
    const { textStart, offsetStart, textEnd, offsetEnd } = selectionDetails;
    const nodeTexts = textNodesBetween(textStart, textEnd);
    const highlight = makeHighlightNode(textStart, offsetStart, textEnd, offsetEnd, created);
    for (let i = 0, ii = nodeTexts.length; i < ii; i++) {
        highlight(nodeTexts[i]);
    }
}

function makeHighlightNode(
    textStart: Node,
    offsetStart: number,
    textEnd: Node,
    offsetEnd: number,
    created: (node: HTMLSpanElement) => void,
) {
    const fragmentShared = document.createDocumentFragment();
    return (textNode: Node) => {
        const fragment = fragmentShared;
        if (textNode === textStart && textNode === textEnd) {
            // Same start & end node
            const { textContent } = textNode;
            if (offsetEnd - offsetStart) {
                const text = textContent.substring(offsetStart, offsetEnd);
                makeTextNode(fragment, textContent.substring(0, offsetStart));
                created(factoryMakeHighlightNode(fragment, text));
                makeTextNode(fragment, textContent.substring(offsetEnd, textContent.length));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else if (textNode === textStart) {
            // Currently at start node.
            const { textContent } = textNode;
            if (textContent.length) {
                makeTextNode(fragment, textContent.substring(0, offsetStart));
                created(factoryMakeHighlightNode(fragment, textContent.substring(offsetStart, textContent.length)));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else if (textNode === textEnd) {
            // Currently at end node.
            const { textContent } = textNode;
            if (offsetEnd) {
                created(factoryMakeHighlightNode(fragment, textContent.substring(0, offsetEnd)));
                makeTextNode(fragment, textContent.substring(offsetEnd, textContent.length));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        } else {
            // Currently in fully selected node.
            const { textContent } = textNode;
            if (textContent) {
                created(factoryMakeHighlightNode(fragment, textContent));
                textNode.parentNode.replaceChild(fragment, textNode);
            }
        }
    };
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/abstractselection/applyHighlightSpan.tsx